// extracted by mini-css-extract-plugin
module.exports = {"stars":"Stars_stars__DVuy1"};